@if (media) { @switch (media?.type) {
<!-- images, videos -->
@case (MediaType.VIDEO) {
<atx-video-player
  class="w-100"
  [url]="media.url"
  [posterUrl]="videoPosterUrl"
  [videoAttributes]="videoPlayerProps"
  [objectFit]="objectFit"
>
</atx-video-player>
} @default { @if (!imageTemplateRef) {
<atx-image
  class="w-100"
  [imageUrl]="media.url"
  failedLoadIconSize="5x"
  [fallbackImageUrl]="fallbackImageUrl"
  [objectFit]="objectFit"
  [maxWidth]="maxWidth"
  [imageBreakpoints]="imageBreakpoints"
>
</atx-image>
} @else {
<ng-container
  *ngTemplateOutlet="imageTemplateRef; context: { $implicit: media }"
>
</ng-container>
} } } }
